import { getOrder } from './get-order';
/**
 * Returns the order expiry date.
 */
export const getOrderExpiry = () => {
    const order = getOrder();
    return order && order.expiresAt ? new Date(order.expiresAt) : undefined;
};
